import { connect } from 'react-redux';

import { IReduxState } from '../../types/redux';
import { Filters, IFiltersProps } from '../../components/Filters';

type TFiltersStateProps = Pick<IFiltersProps, 'jsonQuery'>;

function mapStateToProps(state: IReduxState): TFiltersStateProps {
  return {
    jsonQuery: state.filters.jsonQuery,
  };
}

export const FiltersContainer = connect(mapStateToProps)(Filters);
